import ScrollToTop from "../../components/ScrollToTop.tsx";
import setTitleAndMetaDescription from "../../components/setTitleAndMetaDescription.tsx";
import useDatalayer from "../../components/useDatalayer.tsx";
import WhatYouAreGettingSectionComponent from "../../components/alternative-frontpages/WhatYouAreGettingSectionComponent.tsx";
import WorthToKnowSectionComponent from "../../components/alternative-frontpages/WorthToKnowSectionComponent.tsx";
import WhyChooseHiperSectionComponent from "../../components/alternative-frontpages/WhyChooseHiperSectionComponent.tsx";
import {DispatchHighLightAddressSearchEvent} from "../../util/events.ts";
import FibiaHeroComponent from "../../components/hero/FibiaHeroComponent.tsx";
import setNoIndexMeta from "../../components/setNoIndexMeta.tsx";


export default function FibiaPage() {
    ScrollToTop()
    useDatalayer()
    setNoIndexMeta()
    setTitleAndMetaDescription(
        'Stabilt internet til masser af streaming',
        'Hiper er Danmarks bedste internet til markedets bedste pris. Hos os får du alt den hastighed, du skal bruge til at streame, arbejde og blive underholdt.'
    )

    return (
        <div className={"page-campaign-fibia"}>

            <FibiaHeroComponent />

            <section className="section-white">
                <div className="content content--medium">
                    <ul className="grid grid-triple no-boxes">
                        <li>
                            <div className="content content--slim">
                                <div className="blurb">
                                    <h3 className="heading heading--medium heading--left">Fremtidssikr din bolig med fibernet</h3>
                                </div>
                                <p>
                                    Har du en ældre internetforbindelse?
                                    Så anbefaler vi, at du skifter til fiber.
                                    Hvis din internetforbindelse f.eks. er via telefonstikket, så er det en teknologi,
                                    der står til at blive udfaset i de kommende år.
                                    Det betyder, at der i fremtiden ikke længere vil være internet via telefonstikket på din adresse.
                                    Og det vil vi gerne hjælpe dig med at løse.
                                </p>
                            </div>
                        </li>
                        <li>
                            <div className="content content--slim">
                                <div className="blurb">
                                    <h3 className="heading heading--medium heading--left">Få de første 6 mdr. fra kun <strong><span className="hiper-text-stroke">149</span> kr./md.</strong>
                                    </h3>
                                </div>
                                <p>
                                    Lige nu kan du blive koblet på fibernettet helt gratis.
                                    Du får nemlig oprettelse og tilslutning til <strong>0&nbsp;kr.</strong><br/>
                                    <button className={"link"} onClick={() => DispatchHighLightAddressSearchEvent(true)}>
                                        Tjek din adresse her.
                                    </button>
                                </p>
                                <p>
                                    Vi glæder os til at give dit hjem lynhurtigt fiber!
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
            </section>

            <WhatYouAreGettingSectionComponent/>
            <WorthToKnowSectionComponent/>
            <WhyChooseHiperSectionComponent/>
        </div>
    )
}
